import { useState } from "react";
import { contactoServices } from "../../../../services/contacto.services";
import "./contacto.scss";

export default function Contacto() {
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [asunto, setAsunto] = useState("");
  const [consulta, setConsulta] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError("");
    contactoServices
      .send({
        recipient: "cofolp@gmail.com",
        subject: asunto,
        body:
          `<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden;">` +
          `<div style="background: #1e293b; padding: 24px 32px;">` +
          `<h2 style="color: white; margin: 0; font-size: 1.2rem;">${asunto}</h2>` +
          `<p style="color: #94a3b8; margin: 4px 0 0 0; font-size: 0.85rem;">Colegio de Fonoaudiólogos de La Pampa</p>` +
          `</div>` +
          `<div style="padding: 32px;">` +
          `<table style="width: 100%; border-collapse: collapse;">` +
          `<tr><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #64748b; width: 30%; font-size: 0.9rem;">Nombre</td><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #1e293b; font-weight: 600;">${nombre}</td></tr>` +
          `<tr><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #64748b; font-size: 0.9rem;">Email</td><td style="padding: 10px 0; border-bottom: 1px solid #f1f5f9; color: #1e293b; font-weight: 600;">${email}</td></tr>` +
          `</table>` +
          `<div style="margin-top: 24px; padding: 20px; background: #f8fafc; border-radius: 6px; color: #334155; font-size: 0.9rem; line-height: 1.7;">${consulta}</div>` +
          `</div>` +
          `<div style="background: #f8fafc; padding: 16px 32px; font-size: 0.8rem; color: #94a3b8; text-align: center;">` +
          `Este mensaje fue generado automáticamente desde el portal de COFOLP.` +
          `</div>` +
          `</div>`,
      })
      .then(() => {
        setSuccess(true);
        setNombre("");
        setEmail("");
        setAsunto("");
        setConsulta("");
      })
      .catch(() =>
        setError("No se pudo enviar el mensaje. Intente nuevamente.")
      )
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div className="contact section">
        <div className="container section-title fade-up">
          <h2>Contacto</h2>
        </div>

        <div className="mb-5 fade-up">
          <iframe
            style={{ border: 0, width: "100%", height: "370px" }}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3432.055793259047!2d-64.28344972377954!3d-36.60962886618601!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95c2cda2ffebeb1b%3A0xfa949b07b5275bc8!2sAv.%20Agust%C3%ADn%20Spinetto%20670%2C%20L6300%20Santa%20Rosa%2C%20La%20Pampa!5e1!3m2!1ses-419!2sar!4v1761251729059!5m2!1ses-419!2sar"
            frameBorder="0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="container fade-up">
          <div className="row gy-4">
            <div className="col-lg-6 ">
              <div className="row gy-4">
                <div className="col-lg-12">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center fade-up">
                    <i className="bi bi-geo-alt"></i>
                    <h3>Domicilio</h3>
                    <p>Avda. Spinetto 670 Dpto. 2 A, SANTA ROSA, La Pampa</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center fade-up">
                    <i className="bi bi-telephone"></i>
                    <h3>Teléfonos</h3>
                    <p>02954 - 702284 (Sede)</p>
                    <p>2954 - 295396 (Móvil)</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="info-item d-flex flex-column justify-content-center align-items-center fade-up">
                    <i className="bi bi-envelope"></i>
                    <h3>Email</h3>
                    <p>cofolp@gmail.com</p>
                    <p>asesoramiento-sei@googlegroups.com</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <form onSubmit={handleSubmit} className="contact-form fade-up">
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nombre"
                      value={nombre}
                      onChange={(e) => setNombre(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Asunto"
                      value={asunto}
                      onChange={(e) => setAsunto(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <textarea
                      className="form-control"
                      rows={4}
                      placeholder="Consulta"
                      value={consulta}
                      onChange={(e) => setConsulta(e.target.value)}
                      required
                    ></textarea>
                  </div>

                  <div className="col-md-12 text-center">
                    {loading && <div className="loading">Enviando...</div>}
                    {error && <div className="error-message">{error}</div>}
                    {success && (
                      <div className="sent-message">
                        Su mensaje ha sido enviado. ¡Gracias!
                      </div>
                    )}
                    <button type="submit" disabled={loading}>
                      {loading ? "Enviando..." : "Enviar Mensaje"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
